'use client';
/** @jsxImportSource @emotion/react */

import React, { type ElementType, forwardRef, type Ref } from 'react';

import type {
  OverridableComponent,
  OverrideProps,
} from '@mui/material/OverridableComponent';

import MuiBadge, {
  type BadgeTypeMap as MuiBadgeTypeMap,
} from '@mui/material/Badge';

type ExcludedMuiProps = '';
type CustomProps = {
  component?: ElementType;
};

type BadgeTypeMap<
  P = CustomProps,
  D extends ElementType = MuiBadgeTypeMap['defaultComponent'],
> = {
  defaultComponent: D;
  props: Omit<MuiBadgeTypeMap['props'], ExcludedMuiProps> & P;
};

/**
 * @deprecated Please use `Indicator` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-indicator-migration--indicator-migration-guide Migration guide}
 */
export type BadgeProps<
  D extends ElementType = MuiBadgeTypeMap['defaultComponent'],
  P = CustomProps,
> = OverrideProps<BadgeTypeMap<P, D>, D>;

const BadgeComponent = (props: BadgeProps, ref: Ref<HTMLSpanElement>) => {
  return <MuiBadge {...props} ref={ref} />;
};

BadgeComponent.displayName = 'Badge';

/**
 * @deprecated Please use `Indicator` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-indicator-migration--indicator-migration-guide Migration guide}
 */
export const Badge = forwardRef(
  BadgeComponent
) as OverridableComponent<BadgeTypeMap>;
